<ng-container class="wrapper" [ngSwitch]="BlocSelected.TypeBloc">

  <!--NVARCHAR-->
    <ng-template [ngSwitchCase]="'NVARCHAR'" >
    <div class="contenu-bloc ">
      <div *ngIf="showPopover">
        <input class="q-input-no-border q-input-custom" placeholder="{{BlocSelected.NomBloc}}" (keyup)="OnValueChange(BlocSelected,$event)" [(ngModel)]="BlocSelected.Value" />
      </div>
    </div>
  </ng-template>

  <!--DATETIME-->
  <ng-template [ngSwitchCase]="'DATETIME'">
    <div class="contenu-bloc">
      <div class="q-pointer d-flex align-items-center px-3" *ngIf="!showPopover">
        <i class="far fa-calendar-alt mr-2 color-picto omPicto"></i>
        {{BlocSelected.NomBloc}}
      </div>
      <div *ngIf="showPopover">
        <div class="d-flex align-items-center mb-2 px-3">
          <span class="q-w40px">Du :</span>
          <input type="date" class="q-date q-input-no-border q-input-custom2 color-picto omPicto" (change)="OnFromDateChange(BlocSelected,$event.target.value)" [(ngModel)]="BlocSelected.ValueDateDebut" />
        </div>
        <div class="d-flex align-items-center px-3">
          <span class="q-w40px">Au :</span>
          <input type="date" class="q-date q-input-no-border q-input-custom2 color-picto omPicto" (change)="OnToDateChange(BlocSelected, $event.target.value)" [(ngModel)]="BlocSelected.ValueDateFin" />
        </div>
      </div>
    </div>
  </ng-template>

  <!--TIME-->
  <ng-template [ngSwitchCase]="'TIME'">
    <div class="contenu-bloc">
      <div class="q-pointer d-flex align-items-center px-3" *ngIf="!showPopover">
        <i class="far fa-clock mr-2 color-picto omPicto"></i>
        {{BlocSelected.NomBloc}}
      </div>
      <div *ngIf="showPopover">
        <div class="d-flex align-items-center mb-2">
          <input class="q-input" type="time" step="2" (change)="OnValueChange(BlocSelected,$event)" [(ngModel)]="BlocSelected.Value">
          <select class="q-main-select ml-2" [(ngModel)]="BlocSelected.Operator" (change)="OnOperatorChange(BlocSelected,$event.target.value)">
            <option value=">=">Min</option>
            <option value="<=">Max</option>
          </select>
        </div>
      </div>
    </div>
  </ng-template>

  <!--MONEY-->
  <ng-template [ngSwitchCase]="'MONEY'">
    <div class="contenu-bloc q-pointer px-3">
      <div class="d-flex align-items-center " *ngIf="!showPopover">
        {{BlocSelected.NomBloc}}
      </div>
      <div *ngIf="showPopover">
        <div class="d-flex align-items-center">
          <input class="q-input-no-border q-input-custom3" type="number" placeholder="{{BlocSelected.NomBloc}}" min="0" (keyup)="OnValueChange(BlocSelected,$event)" [(ngModel)]="BlocSelected.ValueInt" />
          <select class="q-main-select ml-2" [(ngModel)]="BlocSelected.Operator" (change)="OnOperatorChange(BlocSelected,$event.target.value)">
            <option value=">=">Min</option>
            <option value="<=">Max</option>
          </select>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- INT (comme Money) -->
  <ng-template [ngSwitchCase]="'INT'">
    <div class="contenu-bloc q-pointer px-3">
      <div class="d-flex align-items-center " *ngIf="!showPopover">
        {{BlocSelected.NomBloc}}
      </div>
      <div *ngIf="showPopover">
        <div class="d-flex align-items-center">
          <input class="q-input-no-border q-input-custom3" type="number" placeholder="{{BlocSelected.NomBloc}}" min="0" (keyup)="OnValueChange(BlocSelected,$event)" [(ngModel)]="BlocSelected.ValueInt" />
          <select class="q-main-select ml-2" [(ngModel)]="BlocSelected.Operator" (change)="OnOperatorChange(BlocSelected,$event.target.value)">
            <option value=">=">Min</option>
            <option value="<=">Max</option>
          </select>
        </div>
      </div>
    </div>
  </ng-template>

  <!--NUMBER-->
  <!--<ng-template [ngSwitchCase]="'INT'">
    <div class="contenu-bloc">
      <div class="row mb-2" style=" align-items: center;" *ngIf="!showPopover">
        <i class="fas fa-calculator fa-2x mr-2 omPicto"></i>{{BlocSelected.NomBloc}}
      </div>
      <div *ngIf="showPopover">
        <div style="display: inline-flex;">
          <input class="q-input input-reduit" id="number" type="number" placeholder="{{BlocSelected.NomBloc}}" (keyup)="OnValueChange(BlocSelected,$event)" [(ngModel)]="BlocSelected.ValueInt">
          <select [(ngModel)]="BlocSelected.Operator" (change)="OnOperatorChange(BlocSelected,$event.target.value)" class="q-main-select ml-2" style=" border: 1px solid;">
            <option value=">=">Min</option>
            <option value="<=">Max</option>
          </select>
        </div>
      </div>
    </div>

  </ng-template>-->
  <!--BOOLEAN-->
  <ng-template [ngSwitchCase]="'BOOLEAN'">
    <div class="contenu-bloc q-pointer px-3">
      <div *ngIf="!showPopover">
        <span class="mr-1">{{BlocSelected.NomBloc}}</span>
      </div>
      <div *ngIf="showPopover" class="d-flex flex-column">
        <div class="q-boolean-option" [style.border]="getBorderColorOnBoolSelected(BlocSelected, 'NONE')" (click)="OnValueChange(BlocSelected,'NONE')">Indifférent</div>
        <div class="q-boolean-option" [style.border]="getBorderColorOnBoolSelected(BlocSelected, '1')" (click)="OnValueChange(BlocSelected,'1')">Oui</div>
        <div class="q-boolean-option" [style.border]="getBorderColorOnBoolSelected(BlocSelected, '0')" (click)="OnValueChange(BlocSelected,'0')">Non</div>
      </div>
    </div>
  </ng-template>

  <!-- COMBO -->
  <ng-template [ngSwitchCase]="'COMBO'">
    <div class="contenu-bloc q-pointer px-3">
      <div *ngIf="!showPopover">
        <span class="mr-1">{{BlocSelected.NomBloc}}</span>
      </div>
      <div *ngIf="showPopover" class="d-flex flex-column">
        <!--<span class="mr-1">{{BlocSelected.NomBloc}}</span>
        <select class="q-select-combo q-pointer" (change)="OnValueChange(BlocSelected,$event.target.value)">
          <option value="NONE" [selected]="BlocSelected.Value == 'NONE'">Indifférent</option>
          <option *ngFor="let option of listValue" [selected]="BlocSelected.Value == option.Value" value="{{option.Value}}">{{option.Text}}</option>
        </select>-->

        <div class="q-combo-option" [style.border]="getBorderColorOnBoolSelected(BlocSelected, 'NONE')" (click)="OnValueChange(BlocSelected,'NONE')">Indifférent</div>
        <div class="q-combo-option" [style.border]="getBorderColorOnBoolSelected(BlocSelected,  option.Value)" *ngFor="let option of listValue" (click)="OnValueChange(BlocSelected, option.Value)">{{option.Text}}</div>

      </div>
    </div>
  </ng-template>

  <!-- DEFAUT -->
  <ng-template [ngSwitchDefault]>
    <div class="contenu-bloc q-pointer px-3">
      <div *ngIf="!showPopover">
        <span class="mr-1">Type non géré {{BlocSelected.GroupType}}</span>
      </div>
    </div>
  </ng-template>

</ng-container>


<!--<ng-template #Input>
  <div>
    <input class="q-input input-reduit" placeholder="{{BlocSelected.NomBloc}}" (keyup)="OnValueChange(BlocSelected,$event)" [(ngModel)]="BlocSelected.Value"/>
  </div>
</ng-template>

<ng-template #DatePicker>
  <div style="display: inline-flex; align-items: baseline; width: 93%; margin-left: 5%;">
    Du :<input type="date" class="q-date input-reduit" (change)="OnFromDateChange(BlocSelected,$event.target.value)" [(ngModel)]="BlocSelected.ValueDateDebut"/>
  </div>
  <div style="display: inline-flex; margin-top: 0.5em; align-items: baseline; width: 93%; margin-left: 5%;">
    Au :<input type="date" class="q-date input-reduit" (change)="OnToDateChange(BlocSelected, $event.target.value)" [(ngModel)]="BlocSelected.ValueDateFin"/>
  </div>
</ng-template>

<ng-template #Money>
  <div style="display: inline-flex;">
    <input class="q-input input-reduit" type="number" placeholder="{{BlocSelected.NomBloc}}" min="0" (keyup)="OnValueChange(BlocSelected,$event)" [(ngModel)]="BlocSelected.ValueInt" />
    <select [(ngModel)]="BlocSelected.Operator" (change)="OnOperatorChange(BlocSelected,$event.target.value)" class="q-main-select ml-2" style=" border: 1px solid;">
      <option value=">=">Min</option>
      <option value="<=">Max</option>
    </select>
  </div>
</ng-template>

<ng-template #Number>
  <div style="display: inline-flex;">
    <input class="q-input input-reduit" id="number" type="number" placeholder="{{BlocSelected.NomBloc}}" (keyup)="OnValueChange(BlocSelected,$event)" [(ngModel)]="BlocSelected.ValueInt">
    <select [(ngModel)]="BlocSelected.Operator" (change)="OnOperatorChange(BlocSelected,$event.target.value)" class="q-main-select ml-2" style=" border: 1px solid;">
      <option value=">=">Min</option>
      <option value="<=">Max</option>
    </select>
  </div>
</ng-template>

<ng-template #BoolSwitch>
  <div class="checkbox checbox-switch switch-primary switch-background-white">
    <label > {{BlocSelected.NomBloc}}
      <input type="checkbox" name="bool" (change)="OnValueChange(BlocSelected,$event)" [(ngModel)]="BlocSelected.ValueBool"/>
      <span></span>
    </label>
  </div>
</ng-template>

<ng-template #Time>
  <div style="display: inline-flex;">

      <input class="q-input" type="time" placeholder="{{BlocSelected.NomBloc}}" step="2" (change)="OnValueChange(BlocSelected,$event)" [(ngModel)]="BlocSelected.Value">
      <select [(ngModel)]="BlocSelected.Operator" (change)="OnOperatorChange(BlocSelected,$event.target.value)" class="q-main-select ml-2" style=" border: 1px solid;">
        <option value=">=">Min</option>
        <option value="<=">Max</option>
      </select>

  </div>
</ng-template>-->
